











































































import { Component, Vue, Watch } from "vue-property-decorator";

import { adduser } from "@/api/register";
@Component({
  name: "Login",
})
export default class extends Vue {
  private form = {
    loginName: "",
    organName: "",
    phone: "",
    pwd: "",
    role: 0,
    sex: 0,
    userName: "",
    copesd: "",
  };
  // 自定义校验规则
  private validatePass2(rule, value, callback) {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== this.form.pwd) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  }
  private submitForm() {
    (this.$refs.form as any).validate((valid) => {
      if (valid) {
        const param = {
          isuse: 1,
          loginName: this.form.loginName,
          organName: this.form.organName,
          phone: this.form.phone,
          pwd: this.form.pwd,
          role: 1,
          sex: this.form.sex,
          userName: this.form.userName,
        };
        adduser(param).then((res) => {
          if (res.code == 200) {
            this.$message.success("注册成功，即将跳转到登录页....");
            setTimeout(() => {
              this.$router.push("/login");
              window.sessionStorage.clear();
            }, 1500);
          } else if (res.code === 201) {
            this.$message.warning("登录名已存在，请检查后重新提交");
          } else if (res.code == 108) {
            this.$message.warning("登录名或手机号重复，请检查后重新提交");
          }
        });
      } else {
        return false;
      }
    });
  }
  private closeform() {
    this.$router.push("/login");
  }
  private;
  // 校验规则
  private rules = {
    loginName: [{ required: true, message: "请输入登录名", trigger: "blur" }],
    organName: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
    userName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
    sex: [{ required: true, message: "请输入用户名", trigger: "change" }],
    pwd: [
      { required: true, message: "请输入密码", trigger: "blur" },
      { min: 8, message: "密码最少8位", trigger: "blur" },
      { pattern: /[a-zA-Z][0-9]/, message: '请输入不少于8位(字母和数字组合)', trigger: 'blur'}
    ],
    phone: [
      { required: true, message: "请填写联系方式", trigger: "blur" },
      {
        pattern: /^1[3|4|5|7|8][0-9]{9}$/,
        message: "输入得联系方式有误",
        trigger: "blur",
      },
    ],
    copesd: [
      {
        required: true,
        validator: this.validatePass2,
        trigger: "blur",
      },
    ],
  };
}
